// extracted by mini-css-extract-plugin
export default {"root":"addNoteBtn_root__BmvfI","glowing":"addNoteBtn_glowing__3RdUN"};